import {useState} from "react";
import {PlanExtensionCatalogEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_catalog.entity";

export const useModalExtensions = () => {

    const [visibleModalCancelExtension, setVisibleModalCancelExtension] = useState<{
        visible: boolean,
        extension: PlanExtensionCatalogEntity | null
    }>({visible: false, extension: null});

    const [visibleModalReactivateExtension, setVisibleModalReactivateExtension] = useState<{
        visible: boolean,
        extension: PlanExtensionCatalogEntity | null
    }>({visible: false, extension: null});

    const [visibleModalCancelActivation, setVisibleModalCancelActivation] = useState<{
        visible: boolean,
        extension: PlanExtensionCatalogEntity | null
    }>({visible: false, extension: null});

    return {
        visibleModalCancelExtension,
        setVisibleModalCancelExtension,
        visibleModalReactivateExtension,
        setVisibleModalReactivateExtension,
        visibleModalCancelActivation,
        setVisibleModalCancelActivation,
    }
}
